import React from 'react';
import { CheckCircle } from 'lucide-react';
import { features, footerLinks } from '../../data/mock';
import { Link } from 'react-router-dom';

const AuthLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex">
      {/* Left Side - Blue Branding Panel */}
            <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-[#29beff] to-[#1a9edb] relative overflow-hidden">
        {/* Subtle background pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-10 w-64 h-64 bg-white/20 rounded-full blur-3xl" />
          <div className="absolute bottom-40 right-10 w-96 h-96 bg-white/10 rounded-full blur-3xl" />
        </div>
        
        <div className="relative z-10 flex flex-col justify-between p-12 w-full">
          <div>
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-4 leading-tight">
              Professionelles AutoschadenManagement
            </h1>
            <p className="text-blue-100 text-lg mb-10">
              Verwalten Sie Ihre Glasschäden effizient und professionell.
            </p>
            
            {/* Feature List */}
            <div className="space-y-4">
              {features.map((feature) => (
                <div key={feature.id} className="flex items-center gap-3">
                  <CheckCircle className="w-5 h-5 text-cyan-300 flex-shrink-0" />
                  <span className="text-blue-100">{feature.text}</span>
                </div>
              ))}
            </div>
          </div>
          
          {/* Copyright */}
          <div className="text-blue-200 text-sm">
            © 2024 Autogutachter24 - Alle Rechte vorbehalten
          </div>
        </div>
      </div>
      
      {/* Right Side - Content Area */}
      <div className="w-full lg:w-1/2 bg-gray-50 flex flex-col min-h-screen">
        <div className="flex-1 flex items-center justify-center px-6 py-8">
          {children}
        </div>
        
        {/* Footer Links */}
        <div className="py-6 text-center">
          <div className="flex items-center justify-center gap-2 text-sm text-gray-500">
            {footerLinks.map((link, index) => (
              <React.Fragment key={link.id}>
                <Link 
                  to={link.href} 
                  className="hover:text-blue-600 transition-colors"
                >
                  {link.text}
                </Link>
                {index < footerLinks.length - 1 && (
                  <span className="text-gray-300">•</span>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
